import { forEach } from 'lodash'
import { CaseData } from '../apis/inventoryCase.api'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (
    inventoryCases: CaseData[]
  ): TableHorizontalData<CaseData>[] {
    forEach(inventoryCases,
      (inventoryCase: TableHorizontalData<CaseData>) => {
        const actions: ActionName[] = ['print']
        inventoryCase.actions = actions
      })
    return inventoryCases
  }
}
